// Update add to cart button price on click variant and subscription 
  var updatePrice = function() {
    var price = $(this).closest("form").find(".product-price-container .get-price").html();
    $(".add-to-cart-submit-button").find("span").html(price);
  };

//Update auto ship and save price when one time subscription plan is selected 
function updateAutoShipPrice() {
  var index;
  $(".variant-pack-button").each(function(){
    if($(this).hasClass('variant_active')){
      index = $(this).index()+1;
    }
  });

  // Check if index is 4, and change it to 3 if it is
  if (index === 4) {
    index = 3;
  }

  $(".subscription-variants").each(function(){
    var subscriptionIndex = $(this).index();
    if(index === subscriptionIndex){
      var dataSubsciptionVariantPrice = $(this).find("input:first").attr("data-subsciption-variant-price");
      var dataDiscountValue = $(this).find("input:first").attr("data-discount-value");
      $(".data-subsciption-variant-price").text(dataSubsciptionVariantPrice);
      $(".subscription-save-discount").html("Save " + dataDiscountValue);
    }
  });
}


//Update save Price 
function updateSavePrice() {
  var $subscriptionChecked = $(".pdp_subscription input.subscription-purchase-plan:checked").length > 0;
  var $productPriceContainer = $(".product-price-container");
  var $tertiaryBadge = $productPriceContainer.find(".teritary_badge");
  var $tertiaryDiscountPrice = $productPriceContainer.find(".teritary-discount-price");
  if ($subscriptionChecked) {
      var $weeklyPlanChecked = $('.subscription-weekly-plan-option:checked').length > 0;
      if ($weeklyPlanChecked) {
          
          // Subscription Save up to value update
          var match = $('[x-text="defaultSavingsSummary"]').text().match(/(\d+)%/);
          if (match) {
            $(".subscription-save-discount").html("Save " + match[0]);
          }
        
          // Show tertiary badge if hidden
          if ($tertiaryBadge.is(":hidden")) {
              $tertiaryBadge.show();
          }
          // Update subscription save price after a delay
          setTimeout(function () {
              var subscriptionSavePrice = $('.subscription-variants:visible').find('.subscription-weekly-plan-option:checked').attr("subscription-save-price");
              $tertiaryDiscountPrice.html(subscriptionSavePrice);
          }, 100);
      } else {
          // Update save price for active variant
          updateSavePriceForActiveVariant();
          updateAutoShipPrice();
      }
  } else {
      // Handle non-subscription case
      updateSavePriceForActiveVariant();
      updateAutoShipPrice();
  }
  
  // Tertiary badge update
function updateSavePriceForActiveVariant() {
    var savePrice = $(".three_variants .variant-pack-button.variant_active .variant-save-price-discount").html();
    if (savePrice) {
        $tertiaryBadge.show();
        $tertiaryDiscountPrice.html(savePrice);
    } else {
        $tertiaryBadge.hide();
    }
  }
}
$(document).ready(function(){
      // Attach the event handler to both click and change events
      $(document).on("click change", ".three_variants .variant-pack-button, .pdp_subscription input", updatePrice);
    
      // Trigger the event handler function on page load
      $(".three_variants .variant-pack-button, .pdp_subscription input").each(function() {
          updatePrice.call(this);
      });

    // Run on page load
    updateSavePrice();

    // Run on button click
    $(document).on("click", ".three_variants .variant-pack-button", function() {
        updateSavePrice();
    });

    $(document).on("change", ".pdp_subscription input", function(){
       updateSavePrice();
    });
  
    var selectedVariantIndex;
    $(document).on("click", ".ajax-cart-button", function() {
      var variantID =  $(this).attr("data-variant-id");
      var variantTitle =  $(this).attr("data-variant-title");
      // if (selectedVariantIndex == undefined) {
      //   $(".variant-pack-button").each(function(){
      //     if($(this).hasClass('variant_active')){
      //       selectedVariantIndex = $(this).index()+1;
      //       return false; 
      //     }
      //   });
      // }
      
      $(this).parents('body').find('.variant-pack-button-'+ variantTitle).trigger("click");
      // $(this).parents('body').find('.variant-pack-button-'+ variantTitle).addClass('testiiiinggg');
      setTimeout(function () {
        $(this).parents('body').find(".pdp_subscription_item:first label").trigger("click"); 
        $(this).parents('body').find('.add-to-cart-submit-button').trigger("click"); 
        $(this).parents('body').find('.menu-drawer-close-icon').trigger("click"); 
       $('html, body').animate({ scrollTop: 0 }, 'fast');
      }.bind(this), 100);
      
      function checkForOpenClass() {
        var targetElement = $('.cart_drawer'); // Replace with your actual selector

        if (targetElement.hasClass('opacity-100')) {
          $('html, body').animate({ scrollTop: 0 }, 'fast'); // Scroll to top
          clearInterval(checkInterval);
        }
      }

      // Initial check
      checkForOpenClass();
  
      // Set an interval to keep checking
      checkInterval = setInterval(checkForOpenClass, 100);
    });

  // Frequently Asked questions first open click js
  $('.accordion-content-first-button').trigger('click');
});